import { css } from "glamor";
import { Tooltip } from "antd";

const styles = {
    riskLevelIndicator: css({
        width: "10px",
        height: "10px",
        borderRadius: "50%",
    }),
};

const labels = ["Unknown", "Low", "Medium", "High"];

const colours = [
    // UNKNOWN
    "#bdbdbd",
    // LOW
    "#7ed321",
    // MEDIUM
    "#f5a623",
    // HIGH
    "#d0021b",
];

const RiskLevel = ({ level }) => (
    <Tooltip title={labels[level]}>
        <div
            className={styles.riskLevelIndicator}
            style={{ backgroundColor: colours[level] }}
        />
    </Tooltip>
);

export default RiskLevel;
